// extracted by mini-css-extract-plugin
export default {"title_box":"datasComponent_title_box__eq-pd","img_box":"datasComponent_img_box__yTo+R","single_img":"datasComponent_single_img__Ral5j","btn":"datasComponent_btn__fBP+j"};